export class WidgetInstance {
   id: string;
}
